module.exports = __webpack_public_path__ + "static/media/Inter-VariableFont_slnt,wght.bcdd27d4.ttf";